module.exports = __webpack_public_path__ + "static/kamisato-ayato-button-50e7bfbfdf399b85f78f1f2b005af5d4.png";